export const removePrefix = (s: string, prefix: string) => (s.startsWith(prefix) ? s.slice(prefix.length) : s);

export const removeSuffix = (s: string, suffix: string) => (s.endsWith(suffix) ? s.slice(0, -suffix.length) : s);

export const removeAffixes = (s: string, prefix: string, suffix: string) => removeSuffix(removePrefix(s, prefix), suffix);

export const toTitleCase = (s: string) => s.toLowerCase().replace(/\b(\s\w|^\w)/g, (txt) => txt.toUpperCase());
